import React, { useState, useEffect, PropsWithChildren } from "react";
import { useApolloClient } from "@apollo/client";
import gql from "graphql-tag";

import initializeFeatures from "./initializeFeatures";
import FeatureFlagContext from "./context";
import type { CurrentMember } from "./types";
import { FlagRecord } from "./flags";
import { CURRENT_MEMBER_FRAGMENT } from "../../screens/fragments";
import useCurrentUser from "../useCurrentUser";
import { isPublicPath } from "../../screens/NavigatorScreen/utils";

const USER_QUERY = gql`
  query UserFeatureFlagQuery {
    currentMember {
      ...CurrentMemberFragment
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;

export type UserQueryData = {
  currentMember: CurrentMember;
};

const FeatureFlagProvider = ({ children }: PropsWithChildren<{}>) => {
  const [featureFlags, setFeatureFlags] = useState<FlagRecord>({});
  const { memberNumber } = useCurrentUser();
  const client = useApolloClient();

  useEffect(() => {
    if (isPublicPath()) return;

    const fetchFeatureFlags = async () => {
      const { data } = await client.query<UserQueryData>({ query: USER_QUERY });
      const { currentMember } = data;
      const flags = await initializeFeatures(currentMember);

      if (flags) {
        setFeatureFlags(flags);
      }
    };
    fetchFeatureFlags();
  }, [memberNumber]);

  return <FeatureFlagContext.Provider value={featureFlags}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagProvider;
